const reportOptions = {
  widget: {
    fieldsDomain: 'REPORTWIDGETS',
    reportType: 'Widget',
  },
  content: {
    fieldsDomain: 'REPORTCONTENTS',
    reportType: 'Content',
  },
  target: {
    fieldsDomain: 'REPORTTARGETS',
    reportType: 'Target',
  },
  section: {
    fieldsDomain: 'REPORTSECTIONS',
    reportType: 'Section',
  },
  adgroup: {
    fieldsDomain: 'REPORTADGROUPS',
    reportType: 'AdGroup',
  },
  domain: {
    fieldsDomain: 'REPORTDOMAINS',
    reportType: 'Domain',
  },
  spot: {
    fieldsDomain: 'REPORTSPOTS',
    reportType: 'Spot',
  },
  publisher: {
    fieldsDomain: 'REPORTPUBLISHERS',
    reportType: 'Publisher',
    name: 'Publisher',
  },
  source: {
    fieldsDomain: 'REPORTSOURCES',
    reportType: 'Source',
  },
  keyword: {
    fieldsDomain: 'REPORTKEYWORDS',
    reportType: 'Keyword',
  },
  channel: {
    fieldsDomain: 'REPORTCHANNELS',
    reportType: 'Channel',
  },
  creative: {
    fieldsDomain: 'REPORTCREATIVES',
    reportType: 'Creative',
  },
  group: {
    fieldsDomain: 'REPORTGROUPS',
    reportType: 'Group',
  },
  bid: {
    fieldsDomain: 'REPORTBIDS',
    reportType: 'Bid',
  },
};

const getReportOptions = (options) => options.map((option) => reportOptions[option] || {});

const trafficSourceReportTypes = {
  native: {
    options: getReportOptions(['widget', 'content']),
  },
  mobile: {
    options: getReportOptions(['publisher']),
  },
  adult: {
    options: getReportOptions(['widget']),
  },
  RevContent: {
    options: getReportOptions(['widget', 'content', 'target']),
  },
  Taboola: {
    options: getReportOptions(['widget', 'content']),
  },
  Outbrain: {
    options: getReportOptions(['widget', 'content', 'section']),
  },
  ContentAd: {
    options: getReportOptions(['widget', 'content']),
  },
  Mgid: {
    options: getReportOptions(['widget', 'content']),
  },
  Adskeeper: {
    options: getReportOptions(['widget', 'content']),
  },
  VoluumDSP: {
    options: getReportOptions(['widget', 'content']),
  },
  Gemini: {
    options: getReportOptions(['widget', 'content', 'adgroup', 'domain']),
  },
  YahooDSP: {
    options: getReportOptions(['widget', 'content', 'adgroup', 'domain']),
  },
  Engageya: {
    options: getReportOptions(['widget', 'content']),
  },
  Runative: {
    options: getReportOptions(['widget', 'content', 'spot']),
  },
  ActiveRevenue: {
    options: getReportOptions(['widget', 'content']),
  },
  ZeroPark: {
    options: getReportOptions(['publisher', 'source', 'creative', 'keyword']),
  },
  PopCash: {
    options: getReportOptions(['publisher']),
  },
  PopAds: {
    options: getReportOptions(['publisher']),
  },
  Propeller: {
    options: getReportOptions(['publisher', 'creative']),
  },
  PlugRush: {
    options: getReportOptions(['publisher']),
  },
  ExoClick: {
    options: getReportOptions(['publisher']),
  },
  ClickAdu: {
    options: getReportOptions(['publisher']),
  },
  HillTopAds: {
    options: getReportOptions(['publisher']),
  },
  RtxPops: {
    options: getReportOptions(['publisher', 'channel']),
  },
  MegaPush: {
    options: getReportOptions(['publisher']),
  },
  RichPush: {
    options: getReportOptions(['publisher', 'source', 'creative']),
  },
  ActiveRevenueMobile: {
    options: getReportOptions(['publisher', 'source', 'creative']),
  },
  PushGround: {
    options: getReportOptions(['publisher', 'source', 'creative']),
  },
  Evadav: {
    options: getReportOptions(['source', 'creative']),
  },
  EzMob: {
    options: getReportOptions(['publisher', 'source', 'creative']),
  },
  AdMaven: {
    options: getReportOptions(['publisher', 'source', 'creative']),
  },
  ExoClickAdult: {
    options: getReportOptions(['content', 'spot', 'widget']),
  },
  TrafficForce: {
    options: getReportOptions(['content', 'group', 'spot']),
  },
  TrafficJunky: {
    options: getReportOptions(['content', 'bid']),
  },
  TrafficStars: {
    options: getReportOptions(['content', 'spot', 'widget']),
  },
  Adsterra: {
    options: getReportOptions(['publisher']),
  },
  Facebook: {
    options: getReportOptions(['content, adgroup']),
  },
  Kadam: {
    options: getReportOptions(['publisher', 'creative']),
  },
  BidVertiser: {
    options: getReportOptions(['publisher']),
  },
};

const model = {
  getReportOptions(tsType) {
    if (!tsType) {
      return trafficSourceReportTypes[process.env.VUE_APP_PLATFORM];
    }
    return trafficSourceReportTypes[tsType];
  },
  types: reportOptions,
};

export { model };
